export default __webpack_public_path__ + "static/media/cog-smart-logo.ad732a1f.png";